import {Loader} from '@smart/web-components';
import React from 'react';
import styles from './app-loader.module.scss';
export const AppLoader = () => {
  return (
    <div className={styles.appLoader}>
      <Loader size="medium" messageId={`loading-product-search`} />
    </div>
  );
};
